import Vue from '../main';

export default {
  generarQr({downloadProgress, before}) {
    return Vue.$http.get(`${process.env.VUE_APP_ROOT_API}Empresas/generar-qr`, {
      responseType: 'blob',
      downloadProgress,
      before
    });
  }
}
